export const CIRCLE_RADIUS = 6;
export const CIRCLE_OFFSET = CIRCLE_RADIUS + 2;
